var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._g(_vm._b({attrs:{"items":_vm.items,"hint":_vm.hint,"persistent-hint":"","outlined":"","label":_vm.label,"menu-props":{
    bottom: true,
    offsetY: true,
    closeOnClick: true,
    closeOnContentClick: true,
    auto: true,
    overflowY: true,
  },"prepend-inner-icon":_vm.icon},on:{"input":_vm.clearServerErrors}},'v-autocomplete',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }